var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as ircSupplyActions from 'action/ircSupply';
import * as reportActions from 'action/report';
import CommonReport from 'component/newCommonReport/newCommonReport';
import columns from './columns';
import { formatColumnsByType } from 'utils/formatColumnsByType';
var SupplyDepositType;
(function (SupplyDepositType) {
    SupplyDepositType["RCP"] = "RCP";
    SupplyDepositType["AER"] = "AER";
    SupplyDepositType["DVF"] = "DVF";
})(SupplyDepositType || (SupplyDepositType = {}));
var signalController;
var SupplyPositionNotCounted = function (_a) {
    var auth = _a.auth, translate = _a.translate, fetchReports = _a.fetchReports, fetchFluxGraphData = _a.fetchFluxGraphData, fetchFluxReport = _a.fetchFluxReport, fetchFlux = _a.fetchFlux;
    var _b = useState({}), formData = _b[0], setFormData = _b[1];
    var tableColumns = useState(columns)[0];
    var _c = useState([]), branchids = _c[0], setBranchids = _c[1];
    var _d = useState([]), sectionIds = _d[0], setSectionIds = _d[1];
    useEffect(function () {
    }, [formData]);
    var relatoryOptions = [
        { label: "RCP", value: SupplyDepositType.RCP }, { label: "AER", value: SupplyDepositType.AER }, { label: "DVF", value: SupplyDepositType.DVF, }
    ];
    var fields = [
        {
            type: 'branchs',
            name: 'branchIdList',
            label: translate('irc.store'),
            help_text: translate('field.selectMultiStores'),
            error_text: translate('field_must_be_filled'),
            required: true,
            onChangeValue: function (e) {
                extractBranchs(e);
                setFormData(__assign(__assign({}, formData), { listRegionsAndBranchs: e.target.value }));
            },
        },
        {
            type: 'new_ds_ldap',
            name: 'dsLdaps',
            isLm: true,
            label: translate('irc.section'),
            help_text: translate('irc.choose-section'),
            error_text: translate('field_must_be_filled'),
            required: false,
            onChangeValue: function (e) {
                setFormData(__assign(__assign({}, formData), { dsLdaps: e }));
            },
        },
        {
            type: 'select_multiple',
            name: 'depositType',
            required: true,
            noGroup: true,
            label: "Tipo de depósito",
            help_text: "Selecione um ou mais depósitos",
            attrs: {},
            options: [],
            isDepositTypesSelect: true,
            onChangeValue: function (e) {
                setFormData(__assign(__assign({}, formData), { depositType: e }));
            },
        },
        {
            type: 'date_range',
            name: 'dtRange',
            label: translate('field.period.hint'),
            help_text: translate('kardex.field.dtRef.placeholder'),
            error_text: translate('field_must_be_filled'),
            required: true,
        },
    ];
    function onSubmit(submitData, setResponseInTable) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedValues;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formattedValues = __assign(__assign(__assign({}, formData), submitData), { branchs: branchids, dtEnd: submitData.dtRange ? submitData.dtRange[1] : '', dtStart: submitData.dtRange ? submitData.dtRange[0] : '', hasPagination: true, size: submitData.limit });
                        delete formattedValues.dtRange;
                        setFormData(formattedValues);
                        signalController = new AbortController();
                        return [4 /*yield*/, fetchFlux(auth.user.dsToken, formattedValues, function (response, count) {
                                var valuesFormattedByTypes = formatColumnsByType(columns, response, translate);
                                setResponseInTable({ total: count, data: valuesFormattedByTypes });
                            }, signalController)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var extractSections = function (e) {
        setSectionIds(Object.values(e).map(function (sec) { return sec.value; }));
    };
    var extractBranchs = function (e) {
        var branchs = [];
        for (var _i = 0, _a = e.target.value; _i < _a.length; _i++) {
            var b = _a[_i];
            if (b.idBranches) {
                branchs.push.apply(branchs, b.idBranches);
            }
            else {
                branchs.push(b.value);
            }
        }
        branchs = branchs.filter(function (b, p) { return branchs.indexOf(b) === p; });
        setBranchids(branchs);
    };
    return (_jsx(CommonReport, { isFlux: true, title: "Relatório do IRC - Posições não contadas - Supply", onSubmit: onSubmit, onExport: function () { return console.log(""); }, columns: tableColumns, fields: fields, label: " ", user: auth.user, limit: 10, translate: translate, emptyReportMsg: 'no.data.found', order: true, customEmptyText: true, defaultOrder: 'date' }));
};
var mapStateToProps = function (_a) {
    var newIrcSupplyReducer = _a.newIrcSupplyReducer, paginateReducer = _a.paginateReducer;
    return ({
        auditPriceReportList: newIrcSupplyReducer.list,
        pages: paginateReducer.pages,
        count: paginateReducer.count,
        current: paginateReducer.current,
    });
};
function mapDispatchToProps(dispatch) {
    return bindActionCreators(__assign(__assign({}, ircSupplyActions), reportActions), dispatch);
}
var AuditPriceTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate',
})(SupplyPositionNotCounted);
export default connect(mapStateToProps, mapDispatchToProps)(AuditPriceTranslated);
